// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__2Ju1g","content":"Layout_content__63GdC"};